import { IHttpApi } from '@cian/http-api/shared';

import { ResponseError } from '../../errors';
import { fetchCreateReview, TCreateReviewResponse } from '../../repositories/newbuilding-reviews/v1/create-review';
import { prepareNewReviews } from '../../mappers/prepareNewReviews';
import { INewReview } from '../../types/newReview';

export interface IFetchReviewsParams {
  httpApi: IHttpApi;
  parameters: {
    newbuildingId: number;
    newReview: INewReview;
  };
}

export async function addReview({
  httpApi,
  parameters: { newbuildingId, newReview },
}: IFetchReviewsParams): Promise<void> {
  const result: TCreateReviewResponse = await fetchCreateReview({
    httpApi,
    parameters: prepareNewReviews(newbuildingId, newReview),
  });

  if (result.statusCode !== 200) {
    throw new ResponseError({
      domain: 'reviews#fetchReviews',
      message: '',
    });
  }
}
